import { StepType } from '@selfai-platform/aggregator-api';

export const stepTypeDefault = [
  { name: 'Condition', value: StepType.FILTER },
  { name: 'Aggregation', value: StepType.AGGREGATOR },
  { name: 'Parallel', value: StepType.PARALLEL },
  { name: 'To', value: StepType.TO },
  { name: 'Variable', value: StepType.VARIABLE },
];
